import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '../Button';
import { LightenDarkenColor } from '../../utils/colorModifier';
import { useSelector } from 'react-redux';
import { faStar, faHeadset } from '@fortawesome/free-solid-svg-icons';

interface Props {
    task: string;
    buttonMessage: string;
    color: 'yellow' | 'red' | 'blue' | 'grey' | 'green';
    customColor?: string;
    isLoading?: boolean;
    fn?: any;
    faIcon?: any;
}

const ButtonDialog = (props: Props) => {
    const botFontSize = useSelector(
        (state: { settings: { botFontSize: number } }) =>
            state.settings.botFontSize
    );

    const fontSizesRef = ['xs', 'sm', 'md', 'lg', 'xl'];
    const smallFontSizeRef = ['2xs', 'xs', 'sm', 'md', 'lg'];
    const fontSizes = [
        fontSizesRef[0 + botFontSize],
        fontSizesRef[1 + botFontSize],
        fontSizesRef[2 + botFontSize],
    ];
    const smallFontSizes = [
        smallFontSizeRef[0 + botFontSize],
        smallFontSizeRef[1 + botFontSize],
        smallFontSizeRef[2 + botFontSize],
    ];
    return (
        <div
            className='w-full rounded-xl flex mb-1 justify-center items-center'
        >
            <Button
                fns={[{ type: 'js', func: props.fn }]}
                style={{backgroundColor: `${props.customColor?.slice(0,7)}`}}
                className={classNames(
                    `rounded-xl flex p-2 m-2 text-white text-${fontSizes[0]} small:text-${fontSizes[0]} medium:text-${fontSizes[1]} large:text-${fontSizes[2]}`,
                    {
                        'bg-yellow-400':
                            props.color == 'yellow' && !props.customColor,
                        'bg-red-400':
                            props.color == 'red' && !props.customColor,
                        'bg-blue-400':
                            props.color == 'blue' && !props.customColor,
                        'bg-slate-400':
                            props.color == 'grey' && !props.customColor,
                        'bg-lime-400 ':
                            props.color == 'green' && !props.customColor,
                    }
                )}
            >
                {/* <svg
                    role="status"
                    className="inline mr-1 w-4 h-4 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                    />
                    <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                    />
                </svg> */}
                <FontAwesomeIcon
                        icon={faHeadset}
                        className="text-white font-medium text-lg inline-block cursor-pointer mr-2"
                    />
                {props.buttonMessage}
            </Button>
        </div>
    );
};

ButtonDialog.propTypes = {};

export default ButtonDialog;
